module.exports = "Clear and concise reproduction instructions are important for us to be\nable to triage your issue in a timely manner. Note that you can use\n[Markdown](https://guides.github.com/features/mastering-markdown/) to format lists and code.\n"


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/en/stepsHelp.md
// module id = 498
// module chunks = 0